
import React  ,{useEffect , useState} from "react";
import { BiSolidDashboard, BiUser, BiUserPin, BiLogOut } from "react-icons/bi";
import { FiMenu, FiPhoneCall, FiClock } from "react-icons/fi";
import { MdDoNotDisturb,MdOutlinePendingActions, MdCallHistory } from "react-icons/md";

const RecordingSidebar = ({ isSidebarOpen, setIsSidebarOpen, setView, handleLogout, user }) => {

  const [username, setUsername] = useState("User"); // Default fallback

  // Fetch username from localStorage on mount
  useEffect(() => {
    const storedUsername = localStorage.getItem("username") || "User";
    setUsername(storedUsername);
  }, []);

  return (
    <aside
    style={{position:"relative" , position:"sticky", top:0}}
      className={`${isSidebarOpen ? "w-60" : "w-16"
        } bg-gray-50 text-black transition-all duration-300 ease-in-out flex flex-col shadow-md `}
      aria-label="Sidebar"
    >
      <div className="p-4 ">
        <div className="flex items-center justify-between">
          {isSidebarOpen && <h2 className="text-xl font-bold"> Qa Dashboard </h2>}
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="rounded transition-colors"
            aria-label="Toggle sidebar"
          >
            <FiMenu size={24} />
          </button>
        </div>
      </div>
      <nav className="mt-4 flex-grow">
        <div className="px-4 py-2 text-gray-400 uppercase text-sm">
          {isSidebarOpen && "Call Room"}
        </div>
        <ul className="space-y-2 px-2">

        <li>
            <button
              onClick={() => setView("Recordinghistory")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-100 transition-colors"
              aria-label="CRM"
            >
              <BiSolidDashboard size={24} />
              {isSidebarOpen && <span className="ml-3 font-bold ">Qa Dashboard</span>}
            </button>
          </li>
   
        </ul>
      </nav>

      <div className="mt-auto px-3">
        <button
          onClick={handleLogout}
          className="flex items-center w-full p-2 rounded hover:bg-gray-100 transition-colors"
          aria-label="Logout"
        >
          <BiLogOut size={24} />
          {isSidebarOpen && <span className="ml-3">Logout</span>}
        </button>

        <div className="flex items-center w-full p-2 rounded transition-colors mt-4">
          <BiUser size={24} />
          {isSidebarOpen && <span className="ml-3">{username}</span>}
        </div>
      </div>
    </aside>
  );
};

export default RecordingSidebar;
